import { PublicLayout } from "@/components/layout/PublicLayout";
import { Calculator, Scale, Lock, HandCoins } from "lucide-react";

const values = [
  {
    icon: Calculator,
    title: "Clarity, not hype",
    body: "Plain-English estimates of what your points are worth — no jargon, no fluff, no upsell.",
  },
  {
    icon: Scale,
    title: "Unbiased by design",
    body: "We're not a card issuer. Our valuations aim to reflect real-world redemptions, not marketing math.",
  },
  {
    icon: Lock,
    title: "Private by default",
    body: "Subscriber details are stored in a private database and are never sold to third parties.",
  },
  {
    icon: HandCoins,
    title: "More value, less effort",
    body: "Simple guides that help you get the most out of every point — in a few minutes, not hours.",
  },
];

export default function About() {
  return (
    <PublicLayout>
      <div className="mx-auto max-w-7xl px-6 py-16 md:py-24 lg:px-8" data-testid="about-page">
        <div className="grid items-center gap-12 md:grid-cols-2">
          <div>
            <p className="font-heading text-xs font-bold uppercase tracking-[0.2em] text-primary">
              About Peak Points
            </p>
            <h1 className="mt-3 font-heading text-4xl font-black tracking-tighter text-slate-900 sm:text-5xl">
              Points, made simple.
            </h1>
            <p className="mt-6 font-body leading-relaxed text-slate-600">
              Credit-card and travel points can be worth a lot — or almost
              nothing — depending on how you use them. Peak Points exists to make
              that difference obvious with a fast calculator and clear guides.
            </p>
            <p className="mt-4 font-body leading-relaxed text-slate-600">
              We keep it lightweight on purpose: know what your points are worth,
              see the best ways to redeem them, and get occasional tips so you
              never leave value on the table.
            </p>
          </div>
          <div className="overflow-hidden rounded-3xl border border-border shadow-sm">
            <img
              src="https://images.unsplash.com/photo-1469854523086-cc02fe5d8800?crop=entropy&cs=srgb&fm=jpg&w=940&q=80"
              alt="Yellow van on an open road — travel rewards concept"
              className="h-full w-full object-cover"
            />
          </div>
        </div>

        <div className="mt-16 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {values.map((v) => (
            <div
              key={v.title}
              className="rounded-3xl border border-border bg-card p-6 transition-transform duration-200 hover:-translate-y-1"
            >
              <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-primary/10 text-primary">
                <v.icon className="h-5 w-5" />
              </span>
              <h3 className="mt-4 font-heading text-base font-bold tracking-tight text-slate-900">
                {v.title}
              </h3>
              <p className="mt-2 font-body text-sm leading-relaxed text-slate-600">{v.body}</p>
            </div>
          ))}
        </div>
      </div>
    </PublicLayout>
  );
}
